import type { ErrorContext } from "@/lib/logError";

interface ErrorEventLike {
  message?: string;
  filename?: string;
  lineno?: number;
  colno?: number;
}

/**
 * Extracts diagnostic context from a `window` `error` event.
 *
 * iOS WebKit (Chrome/Safari on iOS) reports many errors — notably
 * `RangeError: Maximum call stack size exceeded` — to `window.onerror` with a
 * message + location but a NULL `error` object and an unresolved filename
 * (Sentry then shows a single `undefined:line:col` frame). Passing only
 * `event.error` to `logError` therefore captured nothing useful. This pulls the
 * message and `filename:line:col` into the context object so the OTel log record
 * (Kibana) and the Mixpanel replay console still carry something actionable.
 *
 * See Sentry CUSTOMER-UI-3T.
 */
export function errorEventContext(event: ErrorEventLike): ErrorContext {
  const context: ErrorContext = {};
  if (event.message) context.message = event.message;
  if (event.filename) {
    context.source = `${event.filename}:${event.lineno ?? 0}:${event.colno ?? 0}`;
  }
  return context;
}
